import { backendApi } from "@/services/backend/api";
import { Filter } from "@/shared/lib/filter/filter";
import { ODataList } from "@/services/backend/business-central/api/odata-list";
import { GesecContract } from "@/services/backend/business-central/types/gesec-contract";

const contractApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    businessCentralGesecContractShow: build.query<
      GesecContract,
      ShowGesecContractRequest
    >({
      query: (request) => ({
        url: `/business-central/gesec/contracts`,
        method: "GET",
        params: request,
      }),
    }),
    businessCentralGesecContractList: build.query<
      ODataList<GesecContract>,
      ListGesecContractRequest
    >({
      query: (request) => ({
        url: `/business-central/gesec/contracts/list`,
        method: "GET",
        params: request,
      }),
    }),
  }),
});

export const {
  useBusinessCentralGesecContractShowQuery,
  useBusinessCentralGesecContractListQuery,
} = contractApi;

export type ShowGesecContractRequest = {
  companyId: string;
  contractId: string;
};

export type ListGesecContractRequest = {
  companyId: string;
  customerNo?: Filter<string>;
  customerName?: Filter<string>;
};
